export default {"src":"/_next/static/media/CCJ.ac9433e7.svg","height":18,"width":18};